<style lang="scss">
.workshopHourOuput::-webkit-scrollbar {
  display: none;
}
</style>

<template>
  <div class="workshopHourOuput" ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
        {{ $t('meixiaoshichanliang') }}
      </p>
      <div style="margin-left: 18px;">
        <p style="font-size: 12px;line-height: 22px;color: #C0C4CC;">
          {{ $t('UPH') + ':' + uph }}
        </p>
      </div>
    </div>
    <div id="hourOutputChart" :style="{ height: chartHeight + 'px' }"></div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_workshop_mes_hour_output',
  components: {},

  data() {
    return {
      timmer: null,
      chart: null,
      options: null,
      chartHeight: 0,
      t: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
      v: [0],
      uph: '-'
    };
  },
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getShitHourProduct();
    }
  },

  created() {
    this.timmer = setInterval(() => {
      this.getShitHourProduct();
    }, 120000);
    this.getShitHourProduct();
  },
  activated() {
    this.resize();
  },
  mounted() {
    setTimeout(() => {
      this.initChart();
      this.resize();
    }, 700);

    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {
    async getShitHourProduct() {
      let response = await this.http.get('/web/equipment/getShitHourProduct', { params: { orgId: this.$attrs.orgId } });
      this.t = response.data.list.map(item => {
        return item.t;
      });
      this.v = response.data.list.map(item => {
        return item.v;
      });
      this.uph = response.data.uph;
      this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
      if (!this.chart) {
        setTimeout(() => {
          this.initChart();
        }, 100);
      } else {
        if (this.option.xAxis.length == undefined) {
          this.option.xAxis.data = this.t;
        } else {
          this.option.xAxis[0].data = this.t;
        }
        this.option.series[0].data = this.v;

        this.chart.setOption(this.option);
      }
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        if (!this.chart) {
          return;
        }
        this.chart.getDom().style.height = this.chartHeight + 'px';
        this.chart.resize();
      }, 800);
    },
    initChart() {
      this.option = {
        backgroundColor: null,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          top: '10',
          containLabel: true
        },

        xAxis: {
          show: true,
          type: 'category',
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: '#C0C4CC'
            },
            interval: 'auto'
          },
          axisTick: {
            show: false
          },
          data: this.t
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            min: 0,

            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: '#C0C4CC'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#606672'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('chanliang'),
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#6FE5FF'
                  },
                  {
                    offset: 1,
                    color: '#1C70C6'
                  }
                ]),
                barBorderRadius: 4
              }
            },

            data: this.v
          }
        ]
      };
      var chartDom = document.getElementById('hourOutputChart');
      this.chart = this.echarts.init(chartDom);
      this.option && this.chart.setOption(this.option);
    }
  }
};
</script>
